// extracted by mini-css-extract-plugin
export default {"logoWrap":"Logo_logoWrap__V0w-I","logoTitle":"Logo_logoTitle__CEwR4"};